
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M51.327944 344.293596l437.36626 244.999363a53.635945 53.635945 0 0 0 25.889754 6.823656h0.602087a53.987163 53.987163 0 0 0 26.240972-6.823656l429.689647-244.246754a48.86942 48.86942 0 0 0-0.351217-85.998138L533.399187 14.048704a53.987163 53.987163 0 0 0-52.732814 0L50.976726 258.295458a48.819246 48.819246 0 0 0 0.351218 85.998138z m455.780097-252.425107l375.752658 210.73056-367.925523 209.124994L139.182518 301.043657z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M26.742712 550.357979l452.719486 254.331717a62.617081 62.617081 0 0 0 60.810819 0l454.977314-254.381891a40.139154 40.139154 0 0 0 15.453574-54.890293 40.691068 40.691068 0 0 0-55.191337-15.353227l-445.544613 249.063453-443.286785-248.912931a40.741242 40.741242 0 0 0-55.191337 15.052183 40.139154 40.139154 0 0 0 15.252879 55.090989z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M955.462394 684.523103l-445.544613 249.063452-443.236611-249.013279a40.691068 40.691068 0 0 0-55.191337 15.052183 40.139154 40.139154 0 0 0 15.353226 54.940468l452.719487 254.331716a62.466559 62.466559 0 0 0 60.810819 0l454.977314-254.331716a40.139154 40.139154 0 0 0 15.453574-54.890294 40.640894 40.640894 0 0 0-55.341859-15.15253z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  